import { AssetSvg } from '@/components/foundation/Svg'
import { useTranslator } from '@/hooks/useTranslator'
import { useSelector } from '@/stores/hooks'
import { getMetaRender } from '@/stores/meta'
import { getDurationFromIsoDates } from '@/util/dateUtils'
import type { Schedule } from '@common/types/NextTrip'
import { isoTime } from '@lc/libfmt'
import styles from './Schedule.scss'

export function Schedule({
	schedule,
	displayEmptySpace = true,
}: {
	schedule: Schedule
	displayEmptySpace?: boolean
}) {
	const translator = useTranslator()
	const renderAt = useSelector(getMetaRender)
	if (!schedule?.dateTime) return
	if (!renderAt) return

	const duration = getDurationFromIsoDates(renderAt, schedule.dateTime)
	let time
	if (duration <= 0) {
		time = translator.translate('soon')
	} else if (duration < 60) {
		time = `${duration % 60} ${translator.translate('min')}`
	} else {
		time = isoTime(schedule.dateTime)
	}

	let timeNoRealTime
	if (!schedule.realtime)
		timeNoRealTime = translator.fmtTime(schedule.dateTime, 'short')

	const displayRealtime = () => {
		if (displayEmptySpace || schedule.realtime) {
			return (
				<div className={styles.realtime}>
					{schedule.realtime && (
						<AssetSvg
							className={styles.icon}
							name={'assets/Wifi.svg'}
						/>
					)}
				</div>
			)
		} else return null
	}

	return (
		<div
			className={styles.schedule}
			aria-label={`${translator.translate(timeNoRealTime ? 'lines:aria:next-trips-no-realtime' : 'lines:aria:next-trips-realtime')} ${translator.translate(
				'lines:aria:next-trips',
				{
					time: timeNoRealTime ?? time,
				},
			)}`}
		>
			<div aria-hidden="true">
				{schedule.realtime ? time : timeNoRealTime}
			</div>
			{displayRealtime()}
		</div>
	)
}
